import { Colaborador } from '@/store/catalogos/colaborador';
import { ProveedorModel } from '@/store/catalogos/proveedor';
import { properties } from '@/utils/properties';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoProveedorService {
  private readonly baseUrl = properties.URL_CATALOGOS + 'proveedores';

  constructor(private http: HttpClient) { }

  getAll(): Observable<ProveedorModel[]> {
    return this.http.get<ProveedorModel[]>(this.baseUrl, httpOptions);
  }

  create(proveedor: ProveedorModel): Observable<ProveedorModel> {
    return this.http.post<ProveedorModel>(this.baseUrl, proveedor, httpOptions);
  }

  update(proveedor: ProveedorModel): Observable<ProveedorModel> {
    return this.http.put<ProveedorModel>(`${this.baseUrl}/${proveedor.idProveedor}`, proveedor, httpOptions);
  }


}
